import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage-angular";
import { AuthCredentials } from "../types/Auth/Auth";
import { BaseStorageRepository } from "./abstract/base.storage.repository";

@Injectable({
  providedIn: "root",
})
export class AuthRepository extends BaseStorageRepository<AuthCredentials> {
  constructor(storage: Storage) {
    super(storage, "auth");
  }

  public async setEnvironment(env: string): Promise<AuthCredentials> {
    const auth = await super.get();
    return super.set({ ...auth, env });
  }

  public async getEnvironment(): Promise<string> {
    const auth = await super.get();
    return auth.env;
  }
}
